import React from "react";
import { Modal } from "reactstrap";

const FieldRow = ({ label, value }) => (
  <div className="team-view-modal__field">
    <span className="team-view-modal__field-label">{label}</span>
    <span className="team-view-modal__field-value">{value || <em className="team-view-modal__empty">—</em>}</span>
  </div>
);

const ViewTeamModal = ({ isOpen, toggle, team }) => {
  const initials = team?.name
    ? team.name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase()
    : "?";

  return (
    <Modal className="program-settings modal-md team-view-modal" isOpen={isOpen} toggle={toggle} centered>
      <div className="team-view-modal__header">
        <div className="team-view-modal__header-copy">
          <span className="team-view-modal__eyebrow">Team Member</span>
          <h3 className="team-view-modal__title">{team?.name || "Member Details"}</h3>
          {team?.title && <p className="team-view-modal__subtitle">{team.title}</p>}
        </div>
        <button
          type="button"
          className="team-view-modal__close"
          onClick={toggle}
          aria-label="Close"
        >
          Close
        </button>
      </div>

      <div className="team-view-modal__body">
        <div className="team-view-modal__profile">
          {team?.photo ? (
            <img
              src={`${process.env.REACT_APP_API_STORAGE_URL}/${team.photo}`}
              className="team-view-modal__avatar"
              alt={team.name}
            />
          ) : (
            <div className="team-view-modal__avatar-placeholder">{initials}</div>
          )}
          <div className="team-view-modal__profile-copy">
            <strong className="team-view-modal__name">{team?.name}</strong>
            {team?.title && <span className="team-view-modal__role">{team.title}</span>}
          </div>
        </div>

        <div className="team-view-modal__fields">
          <FieldRow label="Description" value={team?.description} />
          <FieldRow label="Contact Phone" value={team?.contact_phone} />
          <FieldRow label="Contact Email" value={team?.contact_email} />
        </div>
      </div>

      <div className="team-view-modal__footer">
        <button type="button" className="team-view-modal__dismiss" onClick={toggle}>
          Close
        </button>
      </div>
    </Modal>
  );
};

export default ViewTeamModal;
